import { apiRequest } from './api';

export async function getPolicy(type) {
  const params = new URLSearchParams({ type: String(type) });
  return apiRequest(`/api/policies?${params.toString()}`, {
    method: 'GET',
    allowNotFound: true,
  });
}
